import { render } from "./HeaderNotifications.vue?vue&type=template&id=367795fc"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__